import { type BaseCurrencyType, getTypedObjectKeys } from '@pkg/types';

export const currencySymbol: Record<BaseCurrencyType, string> = {
    apt: 'APT',
    eth: 'ETH',
    matic: 'MATIC',
    usd: 'USD',
};

export const currencyName: Record<BaseCurrencyType, string> = {
    apt: 'Aptos',
    eth: 'Ether',
    matic: 'Matic',
    usd: 'USD',
};

export const currencyKeys = getTypedObjectKeys(currencySymbol);
